module.exports = __webpack_public_path__ + "static/media/h4_legaled.ef13ec3b.webp";